import React, { useState } from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import UseAdminDeleteBrand from '../../CustomHooks/Admin/UseAdminDeleteBrand'
import DeletePopUp from '../Layout/DeletePopUp'
import { Link } from 'react-router-dom'

const AdminBrandCard = ({ img, cardText, id }) => {

    const [handleDeleteBrand, show, handleClose, handleShow] = UseAdminDeleteBrand()
    
    return (
        <>
            <DeletePopUp show={show} handleDeleteItem={() => handleDeleteBrand(id)} handleClose={handleClose} />
            <Card className="mt-1 mb-4 border shadow-sm pt-2 px-3">
                <Card.Img src={img} className="admin-card-Img mb-3 d-block mx-auto" />
                <Card.Text className='mb-3 fw-bold fs-20'>{cardText}</Card.Text>
                <Row className='mt-4'>
                    <Col>
                        <Link to={`/admin/editbrand/${id}`}><Button variant="warning" className='w-100 action-button mb-3'>Edit</Button></Link>
                    </Col>
                    <Col>
                        <Button variant="danger" onClick={handleShow} className='w-100 action-button mb-3'>Delete</Button>
                    </Col>
                </Row>
            </Card>
        </>

    )
}

export default AdminBrandCard
